export default "__VITE_ASSET__f745ec57__"